import * as React from "react";
type Props = {
  className?: string,
};
function SvgLock({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-lock"
      className={className}
    >
      <path
        d="M6.66797 7.5V5.83333C6.66797 3.99238 8.16035 2.5 10.0013 2.5C11.8423 2.5 13.3346 3.99238 13.3346 5.83333V7.5M6.83464 17.5H13.168C14.1014 17.5 14.5681 17.5 14.9246 17.3183C15.2382 17.1586 15.4932 16.9036 15.653 16.59C15.8346 16.2335 15.8346 15.7668 15.8346 14.8333V10.1667C15.8346 9.23325 15.8346 8.76654 15.653 8.41002C15.4932 8.09641 15.2382 7.84144 14.9246 7.68166C14.5681 7.5 14.1014 7.5 13.168 7.5H6.83464C5.90121 7.5 5.4345 7.5 5.07798 7.68166C4.76438 7.84144 4.50941 8.09641 4.34962 8.41002C4.16797 8.76654 4.16797 9.23325 4.16797 10.1667V14.8333C4.16797 15.7668 4.16797 16.2335 4.34962 16.59C4.50941 16.9036 4.76438 17.1586 5.07798 17.3183C5.4345 17.5 5.90121 17.5 6.83464 17.5Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  );
}
export default SvgLock;
